<app-back-header 
  [headerText]="'Torna alla dashboard'" 
  (backAction)="backToDashboard()" 
  class="sticky-top">
</app-back-header>

<h3 class="ms-2 mt-2">Notifiche e avvisi</h3>

<mat-chip-set class="ms-1">
  <mat-chip>
    In arrivo
  </mat-chip>
  <!-- <mat-chip 
    (click)="toggleAttachmentFilter()">
    Con allegato
  </mat-chip> -->
  <mat-chip
    (click)="toggleUnreadFilter()">
    Da leggere ({{toReadMessages}})
  </mat-chip>
</mat-chip-set>

<h5 class="ms-2 mt-2">Posta in arrivo</h5>
<p class="ms-2">Clicca su un elemento per espanderne il contenuto.</p>

<!-- messages.component.html -->
<div class="messages-container">
  <!-- <mat-card> -->
    <!-- <mat-card-header>
      <mat-card-title>
        Messagi in arrivo
      </mat-card-title>
    </mat-card-header> -->

    <!-- <mat-card-content> -->

      <!-- Loading State -->
      <div *ngIf="loading" class="loading-container">
        <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
        <p class="mt-3">Caricando notifiche e avvisi...</p>
      </div>

      <!-- Error State -->
      <div *ngIf="error && !loading" class="error-container">
        <mat-icon color="warn">error</mat-icon>
        <p>{{ error }}</p>
        <button mat-raised-button color="primary" (click)="loadMessages()">
          <mat-icon>refresh</mat-icon>
          Riprova
        </button>
      </div>

      <!-- Empty State -->
      <div *ngIf="!loading && !error && messages.length === 0" class="empty-container">
        <mat-icon>inbox</mat-icon>
        <h3>Nessun elemento trovato</h3>
        <p>Niente da leggere al momento.</p>
      </div>

      <!-- Messages List -->
      <mat-list *ngIf="!loading && !error && messages.length > 0">
        <mat-card *ngFor="let message of messages" class="message-item" (click)="openMessageDetail(message)">
          <mat-card-header class="message-header w-100">
            <div class="d-flex justify-content-between align-items-center w-100">
              <div matListItemIcon class="ms-0 message-icon d-flex align-items-center">
                <mat-icon [color]="getMessageTypeColor(message.type)">
                  {{ getMessageTypeIcon(message.type) }}
                </mat-icon>
                <!-- <span *ngIf="message.is_read === false" class="ms-2 new-message-sign">
                  Da leggere
                </span> -->
                <mat-chip-set class="ms-2">                  
                  <mat-chip 
                    *ngIf="message.is_read === false"
                    class="new-message-chip me-0">
                    <!-- <mat-icon matChipAvatar>new</mat-icon> -->
                    Nuovo
                  </mat-chip>
                </mat-chip-set>
              </div>

              <!-- Chips section -->
                <!-- <mat-chip-set>                  
                  <mat-chip 
                    *ngIf="message.is_read === false"
                    color="primary"
                    class="attachment-chip me-0">
                    <mat-icon matChipAvatar>new</mat-icon>
                    Nuovo
                  </mat-chip>
                </mat-chip-set> -->
            </div>
          </mat-card-header>

          <mat-card-content>
            <div class="d-flex message-content-wrapper">
              <!-- Main message content -->
              
              <div class="message-main-content">
                <!-- <div matListItemIcon class="message-icon">
                  <mat-icon [color]="getMessageTypeColor(message.type)">
                    {{ getMessageTypeIcon(message.type) }}
                  </mat-icon>
                </div> -->

                <div class="ms-0 message-text-content">
                  <!-- different bold text if non-read message  -->
                  <div *ngIf="message.is_read === false" matListItemTitle class="non-read-message-title">
                    <strong>{{ message.title || 'Nessun titolo' }}</strong>
                  </div>
                  <div *ngIf="message.is_read === true" matListItemTitle class="message-title">
                    {{ message.title || 'Nessun titolo' }}
                  </div>

                  <div matListItemLine class="message-sender">
                    Da: {{ message.sender || 'Sconosciuto' }}, il {{ message.date | date:'dd/MM/yyyy' }}
                  </div>

                  <div matListItemLine class="message-text">
                    {{ truncateText(message.message, 100) }}
                  </div>
                </div>
              </div>

              <!-- Chips section -->
              <!-- <div class="d-flex justify-content-end">
                <mat-chip-set>
                  <mat-chip 
                    [color]="getMessageTypeColor(message.type)" 
                    variant="outlined"
                    class="type-chip">
                    {{ getMessageTypeLabel(message.type) }}
                  </mat-chip>
                  
                  <mat-chip 
                    *ngIf="hasAttachment(message)"
                    (click)="downloadAttachment(message)"
                    color="primary"
                    class="attachment-chip">
                    <mat-icon matChipAvatar>attach_file</mat-icon>
                    Vedi allegato
                  </mat-chip>
                </mat-chip-set>
              </div> -->
            </div>

            <div>
              <div class="w-100 d-flex justify-content-end">
                <mat-chip-set>
                  <!-- <mat-chip 
                    [color]="getMessageTypeColor(message.type)" 
                    variant="outlined"
                    class="type-chip">
                    {{ getMessageTypeLabel(message.type) }}
                  </mat-chip> -->
                  
                  <mat-chip 
                    *ngIf="hasAttachment(message)"
                    (click)="downloadAttachment(message)"
                    color="primary"
                    class="attachment-chip me-0 mb-0">
                    <mat-icon matChipAvatar>attach_file</mat-icon>
                    Vedi allegato
                  </mat-chip>
                </mat-chip-set>
              </div>
            </div>
          </mat-card-content>

        </mat-card>
      </mat-list>
    <!-- </mat-card-content> -->
  <!-- </mat-card> -->
</div>

